module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch3"
  }, [_c('div', {
    staticClass: "changeBox"
  }, [_c('div', {
    staticClass: "mianBox clearfix",
    class: {
      small: _vm.size == 'small'
    }
  }, [_c('div', {
    staticClass: "leftBox",
    class: {
      active: _vm.checked == 1
    },
    on: {
      "click": function($event) {
        return _vm.change(1)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title1))])]), _vm._v(" "), _c('div', {
    staticClass: "rightBox",
    class: {
      active: _vm.checked == 2
    },
    on: {
      "click": function($event) {
        return _vm.change(2)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title2))])]), _vm._v(" "), _c('div', {
    staticClass: "right2",
    class: {
      active: _vm.checked == 3
    },
    on: {
      "click": function($event) {
        return _vm.change(3)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title3))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7a4ea92e","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaCommon/switch3.vue
// module id = 1809
// module chunks = 107